/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * One CMS API
 * API definition for question paper and current server time endpoints.
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CurrentServerTimeResponse,
  OneAsmQuestionsResponse,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns the CMS server clock as current_datetime (used for time sync with clients).
 * @summary Get current server time
 */
export const getCurrentServerTime = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CurrentServerTimeResponse>(
    { url: `/getCurrentServerTime`, method: "GET", signal },
    options,
  );
};

export const getGetCurrentServerTimeQueryKey = () => {
  return [`/getCurrentServerTime`] as const;
};

export const getGetCurrentServerTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentServerTime>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentServerTime>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentServerTimeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentServerTime>>
  > = ({ signal }) => getCurrentServerTime(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentServerTime>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrentServerTimeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentServerTime>>
>;
export type GetCurrentServerTimeQueryError = void;

export function useGetCurrentServerTime<
  TData = Awaited<ReturnType<typeof getCurrentServerTime>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentServerTime>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentServerTime>>,
          TError,
          Awaited<ReturnType<typeof getCurrentServerTime>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrentServerTime<
  TData = Awaited<ReturnType<typeof getCurrentServerTime>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentServerTime>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentServerTime>>,
          TError,
          Awaited<ReturnType<typeof getCurrentServerTime>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrentServerTime<
  TData = Awaited<ReturnType<typeof getCurrentServerTime>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentServerTime>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get current server time
 */

export function useGetCurrentServerTime<
  TData = Awaited<ReturnType<typeof getCurrentServerTime>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentServerTime>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCurrentServerTimeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns question paper details for the given asset and mode.
 * @summary Get question paper
 */
export const getQuestionPaper = (
  assetId: string,
  mode: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<OneAsmQuestionsResponse>(
    {
      url: `/asset/getAssetFromS3/question_paper/${assetId}/${mode}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetQuestionPaperQueryKey = (
  assetId?: string,
  mode?: string,
) => {
  return [`/asset/getAssetFromS3/question_paper/${assetId}/${mode}`] as const;
};

export const getGetQuestionPaperQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = void,
>(
  assetId: string,
  mode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionPaperQueryKey(assetId, mode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionPaper>>
  > = ({ signal }) => getQuestionPaper(assetId, mode, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(assetId && mode),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionPaper>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuestionPaperQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionPaper>>
>;
export type GetQuestionPaperQueryError = void;

export function useGetQuestionPaper<
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = void,
>(
  assetId: string,
  mode: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionPaper>>,
          TError,
          Awaited<ReturnType<typeof getQuestionPaper>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuestionPaper<
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = void,
>(
  assetId: string,
  mode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionPaper>>,
          TError,
          Awaited<ReturnType<typeof getQuestionPaper>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuestionPaper<
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = void,
>(
  assetId: string,
  mode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get question paper
 */

export function useGetQuestionPaper<
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = void,
>(
  assetId: string,
  mode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuestionPaperQueryOptions(assetId, mode, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
